import React, { useState, useEffect } from "react";
import PropTypes from "prop-types";
import { icons } from "lucide-react";
import { colors } from "../../styles/theme";

const Icon = ({
	name,
	color,
	hoverColor,
	size,
	strokeWidth,
	onClick,
	pointerCursor,
	customStyles,
}) => {
	const [defaultColor, setColor] = useState(color);

	const LucideIcon = icons[name] ?? null;

	const handleMouseEnter = () => {
		if (hoverColor) {
			setColor(hoverColor);
		}
	};

	const handleMouseLeave = () => {
		setColor(color);
	};

	useEffect(() => {
		return () => {
			setColor(color);
		};
	}, [color]);

	return (
		<>
			{LucideIcon && (
				<LucideIcon
					color={defaultColor}
					size={size}
					strokeWidth={strokeWidth}
					onClick={onClick}
					onMouseEnter={handleMouseEnter}
					onMouseLeave={handleMouseLeave}
					style={{
						cursor: pointerCursor ? "pointer" : "default",
						...customStyles,
					}}
				/>
			)}
		</>
	);
};

Icon.propTypes = {
	name: PropTypes.string.isRequired,
	color: PropTypes.string,
	hoverColor: PropTypes.string,
	size: PropTypes.number,
	strokeWidth: PropTypes.number,
	onClick: PropTypes.func,
	pointerCursor: PropTypes.bool,
	customStyles: PropTypes.object,
};

Icon.defaultProps = {
	name: "Home",
	color: colors.black,
	hoverColor: "",
	size: 24,
	strokeWidth: 2,
	pointerCursor: false,
	customStyles: {},
};

export default Icon;
